import apiInternal from './servers/apiInternal';

export interface Param {
  label: string;
  tag: string;
  mask: string | null;
  required: boolean;
}

export interface Query {
  query: string;
  description: string;
  params: Param[];
}

export interface Search {
  search: string;
  description: string;
  queries: Query[];
}

export interface Platform {
  platform: string;
  description: string;
  searches: Search[];
}

export interface Source {
  source: string;
  description: string;
  platforms: Platform[];
}

export interface AbrangenciaResponse {
  success: boolean;
  data: Source[];
}

const abrangencia = {
  getAvailable: async (): Promise<AbrangenciaResponse> => {
    const res = await apiInternal.get(`/available`);
    return res.data;
  },
  getAvailableJusticeSecret: async (): Promise<AbrangenciaResponse> => {
    const res = await apiInternal.get(`/available/segredo-justica`);
    return res.data;
  },
};

export default abrangencia;

